import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './PromisedContentLoader.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isPromise(_vm.value)
    ? _c("Promised", {
        attrs: { promise: _vm.value, "pending-delay": _vm.pendingDelay },
        scopedSlots: _vm._u(
          [
            {
              key: "combined",
              fn: function(ref) {
                var isPending = ref.isPending;
                var isDelayOver = ref.isDelayOver;
                var data = ref.data;
                var error = ref.error;
                return [
                  isDelayOver && isPending
                    ? _c(
                        "ContentLoader",
                        {
                          staticClass: "content-loader",
                          attrs: {
                            width: _vm.width,
                            height: _vm.height,
                            "preserve-aspect-ratio": _vm.preserveAspectRatio,
                            "view-box": _vm.viewBox,
                            "primary-color": "rgba(9, 30, 66, 0.08)",
                            "secondary-color": "rgba(9, 30, 66, 0.13)",
                            speed: 1
                          }
                        },
                        [
                          _vm._t("loader-shape", [
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "0",
                                rx: _vm.height / 2,
                                ry: _vm.height / 2,
                                width: _vm.width,
                                height: _vm.height
                              }
                            })
                          ])
                        ],
                        2
                      )
                    : error
                    ? _vm._t("error-message", [
                        _c("div", { staticClass: "error-message" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(error.message) +
                              "\n            "
                          )
                        ])
                      ])
                    : _vm._t("default", null, { value: data })
                ]
              }
            }
          ],
          null,
          true
        )
      })
    : _c(
        _vm.tag,
        { tag: "component" },
        [_vm._t("default", null, { value: _vm.value })],
        2
      )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-262acb9e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/common/PromisedContentLoader.vue.js